import React, { ReactElement } from 'react';

const ModuleLoadingError = (): ReactElement => <div>Component under development</div>;

ModuleLoadingError.displayName = 'ModuleLoadingError';

export default ModuleLoadingError;
